import { ButtonTypes } from "./Button";

const buttonStyle = (theme: ButtonTypes, customStyle?: any) => {
  const baseStyle: any = {
    borderRadius: 20,
    padding: "10px 20px",
    color: "#fff",
    outline: "none",
    fontFamily: "BrandonTextWeb-Medium",
    border: 0
  }

  if (theme === ButtonTypes.PRIMARY) {
    baseStyle.backgroundColor = "#e4306e";
  }

  return baseStyle;
}

export default buttonStyle;